var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-gallery" },
    [
      !_vm.selectable
        ? _c("vue-gallery", {
            attrs: { images: _vm.images, index: _vm.index },
            on: {
              close: function($event) {
                _vm.index = null
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row q-col-gutter-md" },
        _vm._l(_vm.images, function(image, imageIndex) {
          return _c(
            "div",
            { staticClass: "relative-position", class: _vm.gallerySizeClasses },
            [
              _c("q-img", {
                key: imageIndex,
                staticStyle: {
                  "background-color": "var(--image-placeholder-color)"
                },
                attrs: { src: image, ratio: "1" },
                on: {
                  click: function($event) {
                    return _vm.onImageClick(imageIndex)
                  }
                }
              }),
              _vm._v(" "),
              _vm._t("imageActions", null, {
                image: image,
                imageIndex: imageIndex
              })
            ],
            2
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }